export default {
    state: {
        newsCategories: [],
    },
    mutations: {
        SET_NEWS_CATEGORIES(state, payload) {
            state.newsCategories = payload.newsCategories;
        },
    },
    getters: {
        getNewsCategories: (state) => state.newsCategories,
    },
};